<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <h2 class="card-title-desc">Pending Payments</h2>
          <TableLoading v-if="orders.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="orders.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <template v-slot:actions="slotProps" v-if="checkForPermission(change_order_payment_status_permission) && checkForPermission(mark_order_as_paid_permission)">
                <b-button v-b-modal.mark-as-paid variant="primary" size="sm" class="py-1 text-white" @click="selectOrder(slotProps.row.publicId, slotProps.row.orderBalanceDue)">
                  Make Payment
                </b-button>
              </template>
              <div class="row mb-2">
                <div class="col-3">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Due Status</label>
                    <select class="form-select" @change="dueStatusFilter($event)">
                      <option value="all" selected>All</option>
                      <option :value="1">Due</option>
                      <option :value="2">Not Due</option>
                    </select>
                  </div>
                </div>
              </div>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="orders.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>
        </div>
      </div>
    </div>
    <b-modal
        id="mark-as-paid"
        centered
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Make Payment</h3>
        <mark-as-paid-modal :order-balance-due="orderBalanceDue" @markPaid="markPaid"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('mark-as-paid')">Close</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import moment from "moment";
import DataTable from "@/components/data-table";
import {ALL_CUSTOMER_ORDERS_FINANCE} from "@/gql/orders";
import MarkAsPaidModal from "@/components/finance/mark-as-paid-modal";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Pending Payments",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    TableLoading,
    MarkAsPaidModal,
    DataTable, PageHeader, Layout},
  name: "pending-payments",
  data() {
    return {
      title: "Pending Payments",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Pending Payments",
          active: true
        }
      ],
      change_order_payment_status_permission: permissions.change_order_payment_status_permission,
      mark_order_as_paid_permission: permissions.mark_order_as_paid_permission,
      selected_order: '',
      orderBalanceDue: 0,
      filterValue: '',
      orders: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      paymentStatus: [20, 40],
      paymentDue: 0,
      columns: [
        {
          field: 'customer.customerCode',
          label: 'Customer Code'
        },
        {
          field: 'customer.name',
          label: 'Customer Name'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'paymentDueDate',
          label: 'Payment Due Date',
        },
        {
          field: 'due_status',
          label: 'Due Status',
        },
        {
          field: 'orderStatus',
          label: 'Order Status'
        },
        {
          field: 'paymentStatus',
          label: 'Payment Status'
        },
        {
          field: 'grossOrderTotal',
          label: 'Total'
        },
        {
          field: "orderBalanceDue",
          label: "Balance Due"
        },
        {
          field: 'actions',
          label: 'Action'
        },
      ]
    }
  },
  computed: {
    statusFilter(){
      let records = this.rows
      if (this.filterValue === 'true'){
        records =  this.rows.filter(record => this.isBefore(record.payment_due_date))
      }else if(this.filterValue === 'false'){
        records =  this.rows.filter(record => this.isAfter(record.payment_due_date))
      }
      return records
    }
  },
  apollo: {
    orders: {
      query: ALL_CUSTOMER_ORDERS_FINANCE,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          orderPayment: this.paymentStatus,
          orderStatus: ["601fdbd6-c437-4758-98a2-e807e847f566", "b3180af8-62c8-44ce-8432-64c02c5e5a56", "37bd4482-06ed-409d-845e-bdc6334c5505", "e6c0554c-aed8-4c39-b431-cbc239c0fa40" ], //delivered, loaded, not loaded, open
          paymentDue: this.paymentDue
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      changeOrderPaymentStatus: 'orders/changeOrderPaymentStatus'
    }),
     async markPaid(data){
       const dt = {
         orderId: this.selected_order,
         paymentStatus: data.paymentStatus,
         paymentTypeId: data.paymentType.publicId,
         paymentRef: data.paymentRef,
         amountPaid: data.amountPaid,
         paymentType: data.paymentFull
       }
      await this.changeOrderPaymentStatus(dt).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.orders.refetch()
        }
      })
    },
    selectOrder(orderId, orderBalanceDue){
      this.selected_order = orderId
      this.orderBalanceDue = parseInt(orderBalanceDue)
    },
    searchFn(data){
      this.searchKeyword = data
    },
    isBefore(date){
      return moment(date).isBefore(moment())
    },
    isAfter(date){
      return moment(date).isAfter(moment())
    },
    changeStatusFilter(event){
      this.filterValue = event.target.value
    },
    dueStatusFilter(event){
      const value = event.target.value
      if(event.target.value === 'all'){
        this.paymentDue = 0
      }else {
        this.paymentDue =   parseInt(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
